/* eslint-disable */
import { Badge, Button } from "@material-ui/core";
import { Assignment } from "@material-ui/icons";
import { Options, Column } from "material-table";
import React from "react";

export const optionTables = {
    /** @type Options */
    pageSize: 5,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    search: false,
    sorting: false,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const columnsTablePayAll = props => {
    /** @type Column */
    const array = [
        {
            field: "AcceptedDate",
            title: "Date",
            render: row => (
                <div>
                    {row?.AcceptedDate} {row?.AcceptedTime}
                </div>
            ),
        },
        {
            field: "QueueNo",
            title: "Queue No.",
        },
        {
            field: "PatientHN",
            title: "HN",
        },
        {
            field: "PatientName",
            title: "Name",
        },

        {
            field: "CashierStatus",
            title: "Status",
            cellStyle: { color: "blue" },
            render: obj => {
                /** @description attribute: data-color["...."] >> Wait, Call, Hold, Confirm, transfer, concel */
                const elmStatus = [];
                elmStatus[0] = (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center" data-color="Wait">
                        Wait
                    </div>
                );
                elmStatus[1] = (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center" data-color="Call">
                        Call
                    </div>
                );
                elmStatus[2] = (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center" data-color="Hold">
                        Hold
                    </div>
                );
                elmStatus[3] = (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center" data-color="Cancel">
                        Cancel
                    </div>
                );
                elmStatus[4] = (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center" data-color="Confirm">
                        Confirm
                    </div>
                );
                elmStatus[5] = (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center" data-color="Selected">
                        Selected
                    </div>
                );
                return obj?.CashierStatus !== null && obj?.CashierStatus ? elmStatus[Number(obj?.CashierStatus)] : "-";
            },
        },
        {
            field: "PaymentType",
            title: "Mobile Payment",
            render: obj => {
                /** @description attribute: data-color["...."] >> Wait, Call, Hold, Confirm, transfer, concel */
                const elmStatus = [];
                elmStatus[0] = (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center" data-color="Wait">
                        ไม่มีสิทธ์
                    </div>
                );
                elmStatus[1] = (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center" data-color="Confirm">
                        มีสิทธ์
                    </div>
                );
                return obj?.PaymentType !== null && obj?.PaymentType ? elmStatus[Number(obj?.PaymentType)] : "-";
            },
        },
        {
            field: "MethodStatus",
            title: "Method",
            render: obj => {
                return obj?.MethodStatus === "0" ? (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center text-dark" data-color="Counter">
                        Counter
                    </div>
                ) : obj?.MethodStatus === "1" ? (
                    <div className="btn-app rounded-pill not-effect px-4 py-2 text-center" data-color="Mobile">
                        Mobile
                    </div>
                ) : (
                    ""
                );
            },
        },
        {
            field: "action",
            title: "Action",
            hidden: [3, 4].includes(props?.tabs) ? true : false,
            render: item => (
                <Button
                    onClick={() => {
                        props?.handleToggleModalChangeStatus(item);
                    }}
                    className="btn t-btn-primary"
                    disabled={!props?.thisMenuPermission?.edit}>
                    Actions
                </Button>
            ),
        },
        {
            field: "remark",
            title: "Med",
            hidden: [3, 4].includes(props?.tabs) ? true : false,
            render: item => (
                <Badge
                    variant="dot"
                    invisible={!Boolean(item?.Remark)}
                    /** invisible:false => show , invisible:true => hide */ className="badge-payment-showcomment"
                    color="error">
                    <Button
                        onClick={() => {
                            props?.handleToggleModalSaveDoc(item);
                        }}
                        className="btn t-btn-primary">
                        <Assignment />
                    </Button>
                </Badge>
            ),
        },
        {
            field: "Billings.TotalPrice",
            title: "Total",
            cellStyle: { color: "red" },
            render: obj => {
                return obj?.Billings?.reduce((result, item) => result + (item?.TotalPrice || 0), 0) ?? "-";
            },
        },
        {
            field: "DischargeLocationName",
            title: "Location",
        },
    ];
    return array;
};
